import { ModalCancelledError } from '@/vue/modals/ModalCancelledError';

export const ModalPropsMixin = {
    props: {
        // A unique identifier for this modal.
        modalID: {
            type: Number,
            required: true,
        },
        // A function the modal should call to resolve the promise that opened it.
        resolve: {
            type: Function,
            required: true,
        },
        // A function the modal should call to reject the promise that opened it.
        reject: {
            type: Function,
            required: true,
        },
    },

    methods: {
        cancel() {
            this.reject(new ModalCancelledError('User pressed cancel.'));
        },
    },
};
